<template>
    <v-container fluid>
        <v-row v-if="task">
            <v-col cols="2">
                <v-progress-circular size="64" color="primary" indeterminate></v-progress-circular>
            </v-col>
            <v-col>
                <h2 class="page-title page-title__primary" v-if="isPredict">Идет расчет прогноза</h2>
                <h2 class="page-title page-title__primary" v-else>Идет адаптация модели</h2>
                <p>{{statusText}}</p>
                <p>Шаг {{innerTask.step_number || 0}}</p>
                <v-alert type="error" v-if="task.status === 'error'">{{innerTask.error || 'Неизвестная ошибка'}}</v-alert>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col>
                Расчетная задача пока не создана. Перейдите в раздел "Настройки"
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: ['task', 'visible'],
    data() {
        return {
            progressPollIntervalId: null,
            pollIntervalMs: 10000,
            innerTask: this.task,
            statuses: {
                'input': 'В очереди',
                'init': 'Запуск',
                'adapt': 'Адаптация',
                'optimize': 'Оптимизация',
                'results': 'Сохранение результатов',
                'predict': 'Прогноз',
                'finished': 'Расчет завершен',
                'error': 'Ошибка'
            }
        }
    },
    created() {
        if (!this.isFinished) {
            this.startPoll();
        }
    },
    watch: {
        task: {
            deep: true,
            handler() {
                this.innerTask = this.task;
                this.startPoll();
            }
        },
        isFinished() {
            if (this.isFinished) {
                this.stopPoll();
            }
            else {
                if (this.visible) {
                    this.startPoll();
                }
            }
        },
        visible() {
            if (this.visible) {
                this.startPoll();
            }
            else {
                this.stopPoll();
            }
        }
    },
    methods: {
        startPoll() {
            if (this.progressPollIntervalId) {
                this.stopPoll();
            }

            if (this.task && this.task.problemId) {
                this.progressPollIntervalId = setInterval(async () => {
                    let updatedTasks = await this.$store.dispatch('task/loadItems', {problemId: this.task.problemId});
                    this.innerTask = updatedTasks.find(task => task.id === this.innerTask.id);

                    await this.$store.dispatch('task/setOptimizeItem', this.task.problemId);
                    await this.$store.dispatch('task/setPredictItem', this.task.problemId);
                    await this.$store.dispatch('task/setWellsItem', this.task.problemId);
                }, this.pollIntervalMs);
            }
        },
        stopPoll() {
            if (this.progressPollIntervalId) {
                clearInterval(this.progressPollIntervalId);
                this.progressPollIntervalId = null;
            }
        }
    },
    beforeDestroy() {
        this.stopPoll();
    },
    computed: {
        progress() {
            return this.innerTask && this.innerTask.progress > 0 ? this.innerTask.progress : 0;
        },
        progressText() {
            return this.innerTask && this.innerTask.progress > 0 ? parseFloat(this.innerTask.progress).toFixed(1)+'%' : '0%';
        },
        status() {
            return this.innerTask ? this.innerTask.status || 'Инициализация' : 'Инициализация';
        },
        statusText() {
            return this.innerTask ? this.statuses[this.innerTask.status] || 'Ожидание' : 'Загрузка';
        },
        isFinished() {
            return this.innerTask && this.innerTask.status && this.innerTask.status === 'finished';
        },
        taskType() {
            return this.innerTask?.type || null;
        },
        isPredict() {
            return this.taskType === 'predict';
        }
    }
}
</script>

<style scoped>

</style>
